import { Routes, Route, Navigate } from "react-router-dom"
import PrivateRoute from "./PrivateRoute"
import { publicRoutes, privateRoutes } from "./routes"

import {
	SigninPage,
	SignupPage,
	ValidateSignupPage,
	ForgotPasswordPage,
	ValidateForgotPasswordPage,
} from "features/auth"
import { NotFoundPage, ContactPage, FaqPage } from "features/misc"
import { DashboardPage, RegisterBikePage } from "features/dashboard"
import { AccountPage } from "features/account"
import { BikeDetailsPage, BikeTransferRequestPage, BikePortabilityPage } from "features/bike/"

import {
	SignupProcessProvider,
	SignupProcessConsumer,
	SIGNUP_VALIDATION_STEP,
	ForgotPasswordProcessProvider,
	ForgotPasswordProcessConsumer,
	FORGOT_PASSWORD_VALIDATION_STEP,
} from "features/auth/hooks/"

export const Router = () => (
	<Routes>
		{/* Public */}
		<Route path={publicRoutes.signin.path} element={<SigninPage />} />
		{process.env.REACT_APP_MODE === "production" && (
			<Route path="/" element={<Navigate replace to={publicRoutes.signin.path} />} />
		)}

		<Route path={publicRoutes.contact.path} element={<ContactPage />} />
		<Route path={publicRoutes.faq.path} element={<FaqPage />} />
		<Route
			path={publicRoutes.propertyTransferRequest.path}
			element={<BikeTransferRequestPage />}
		/>

		<Route path={publicRoutes.portabilityRequest.path} element={<BikePortabilityPage />} />
		<Route
			path={publicRoutes.signup.path}
			element={
				<SignupProcessProvider>
					<SignupProcessConsumer>
						{({ signupState }) =>
							signupState.step === SIGNUP_VALIDATION_STEP ? (
								<ValidateSignupPage />
							) : (
								<SignupPage />
							)
						}
					</SignupProcessConsumer>
				</SignupProcessProvider>
			}
		/>
		<Route
			path={publicRoutes.lostPassword.path}
			element={
				<ForgotPasswordProcessProvider>
					<ForgotPasswordProcessConsumer>
						{({ forgotPasswordState }) =>
							forgotPasswordState.step === FORGOT_PASSWORD_VALIDATION_STEP ? (
								<ValidateForgotPasswordPage />
							) : (
								<ForgotPasswordPage />
							)
						}
					</ForgotPasswordProcessConsumer>
				</ForgotPasswordProcessProvider>
			}
		/>
		<Route path={publicRoutes.notFound.path} element={<NotFoundPage />} />

		{/* Dev routes for operators */}
		<Route path={publicRoutes.decathlon.path} element={<SigninPage />} />
		<Route path={publicRoutes.bicycode.path} element={<SigninPage />} />
		<Route path={publicRoutes.moustache.path} element={<NotFoundPage />} />

		{/* Protected - Global */}
		<Route element={<PrivateRoute />}>
			<Route path={privateRoutes.dashboard.path} element={<DashboardPage />} />
			<Route path={privateRoutes.registerBike.path} element={<RegisterBikePage />} />
			<Route path={privateRoutes.bike.path} element={<BikeDetailsPage />} />
			<Route path={privateRoutes.account.path} element={<AccountPage />} />
		</Route>

		<Route path="*" element={<NotFoundPage />} />
	</Routes>
)
